export const routes = {
  home: "/",
  about: {
    index: "/about",
    term: "/about/term",
    privacy: "/about/privacy",
  },
  login: "/auth/login",
  register: "/auth/signup",
  registerInfo: "/auth/signup/info",
  forgotPassword: "/auth/forgot-password",
  messages: "/messages",
  job: {
    list: "/job/list",
    detail: "/job/detail/:id",
    create: "/job/create",
    edit: "/job/edit/:id",
  },
  company: {
    profile: "/company/profile",
    employeeInfo: "/company/employee-info",
    employees: "/company/employees",
    reviews: "/company/reviews",
  },
  applicants: {
    list: "/applicants",
  },
  interview: {
    schedules: "/interview/schedules",
  },
  notifications: "/notifications",
} as const;
